<span class="mb-4 block font-semibold text-default">{{ 'Groups' | translate }}</span>
<ul class="m-0 grid gap-y-3">
     @for (item of groups; track item.group.GroupVersionsID) {
    <li class="flex cursor-pointer justify-between text-sm text-default" (click)="setGroupAsActive(item)" [class.*:font-bold]="item.group.GroupVersionsID == activeGroup.group.GroupVersionsID" [class.*:text-blue-400]="item.group.GroupVersionsID== activeGroup.group.GroupVersionsID">
        <div class="text-default transition duration-300" [class.!text-green-500]="item.checkedQuestions === item.questions.length">{{item.group.Name}}</div>
        <div class="text-default transition duration-300" [class.!text-green-500]="item.checkedQuestions === item.questions.length" >{{item.checkedQuestions}}/{{item.questions.length}}</div>
    </li>
    } 
</ul>
